export default __webpack_public_path__ + "706682a15dbff9430b8880fec2cbd1b8.png";